import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Header } from 'semantic-ui-react';
import { Loader, Wrappers, AGIRep } from '../components';
import { ApiStatuses } from '../api';
import { withAuth, AuthStates } from '../auth';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { authProptypes } from '../auth';
import { FLEX_CENTERED, MYAGIREP } from '../constants';

const MyAGIRep = ({ authUser, analytics, authState, apiStatus }) => {
  // default above works only for undefined, make sure null case below
  const handleEmailClick = () => {
    analytics.trackEvent('Email AGI Rep', {
      isLoggedIn: (authState === AuthStates.SignedIn).toString(),
      'Generic Email Sent Page': 'My AGI Rep Page'
    });
  };

  return (
    <Wrappers.Layout menu type={FLEX_CENTERED}>
      <Wrappers.SegmentFull page={MYAGIREP}>
        <Header as="h1">
          <FormattedMessage
            id="title.agi_rep"
            description="My AGI Rep page title"
            defaultMessage="My AGI Rep"
          />
        </Header>
        <p>
          <FormattedMessage
            id="description.agi_rep"
            description="My AGI Rep page description"
            defaultMessage="We are here to help with any questions you have."
          />
        </p>

        {apiStatus === ApiStatuses.Loading && (
          <Container textAlign="center">
            <Loader active inline size="medium" />
          </Container>
        )}
        {authUser && authUser.dealer && authUser.dealer.agiReps && (
          <AGIRep
            reps={authUser.dealer.agiReps}
            handleEmailClick={handleEmailClick}
          />
        )}
      </Wrappers.SegmentFull>
    </Wrappers.Layout>
  );
};

MyAGIRep.propTypes = {
  analytics: PropTypes.object.isRequired,
  apiStatus: PropTypes.string,
  authState: PropTypes.string,
  authUser: authProptypes.user
};

export default withPageViewTracking()(withAnalytics(withAuth(MyAGIRep)));
